'use client';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import Lottie from 'lottie-react';

import styles from '@/styles/notfound.module.scss';
import Link from 'next/link';
import Navbar from '../navbar';

import nodataAnime from '@/assets/lotties/lonely404.json'

export default function NotFoundComponent() {
  const t = useTranslations('notFound');
  const router = useRouter();

  return (<>
    <Navbar pageTitle={t("PAGE_TITLE")} isCartVisible={false} />

    <div className={styles.main}>
      <div className={styles.orderCompletePage}>
        <div className={styles.mainContent + ' ' + styles.notFoundContent}>
          <Lottie animationData={nodataAnime} loop={true} className={styles.lottie} />

          <h1>{t('title')}</h1>
          <p>{t('description')}</p>

          <Link href="/" className={styles.backButton}>
            <button className={styles.backButton} onClick={() => router.push('/')}>
              {t('goBack')}
            </button>
          </Link>
        </div>
      </div>
    </div>
  </>);
}